module.exports = __webpack_public_path__ + "static/media/malls-bg.001b41d5.jpg";